/**
 * A profile holder who opens someone's link (/u/<id> — a phone-camera scan
 * opens exactly this) is routed to their own Connect screen, which then runs
 * the link as a scan: the same profile-to-profile handshake the in-app
 * scanner and Proximity use (signup-connect step 3). This holds the link
 * across that hop — tab-scoped, read once.
 */

const PENDING_PROFILE_SCAN_KEY = 'pending_profile_scan';

/** Remember the opened link for the Connect screen to scan. */
export const setPendingProfileScan = (url) => {
  sessionStorage.setItem(PENDING_PROFILE_SCAN_KEY, url);
};

/** The pending link, removed as it is read (a scan runs once). */
export const takePendingProfileScan = () => {
  const url = sessionStorage.getItem(PENDING_PROFILE_SCAN_KEY);
  if (url) sessionStorage.removeItem(PENDING_PROFILE_SCAN_KEY);
  return url;
};
